import React from "react";
import {
  PICKUP_STATUS,
  MODIFY_ORDER_TYPE_PROMOTION,
  ORDER_PHASE,
  ORDER_TYPE_DELIVERY,
  ERROR,
} from "../../../constants";
import { changeOrderType } from "../OrderStatus.services";
import { useAppSelector } from "../../../redux/hook";
import { Button } from "@dishopsaas/design-system";
import { Box } from "@mui/material";
import getStyles from "../OrderStatus.styles";
type OrderStatusFooterProps = {
  order: any;
  setIsLoading: React.Dispatch<React.SetStateAction<boolean>>;
  withPadding?: boolean;
  sx?: any
};

export default function OrderStatusFooter({
  order,
  setIsLoading,
  withPadding,
  sx
}: OrderStatusFooterProps) {
  const {
    cancel: { disabled: disabledCancel },
    delivery,
  } = useAppSelector((state) => state.configurationReducer);
  const styles = getStyles()
  if (!order) return null;

  const {
    status,
    cancellableWithRefundAndPromo,
    pickupStatus,
    orderType,
  } = order;

  const orderNotCurrentlySupported =
    pickupStatus === PICKUP_STATUS.ORDER_NOT_CURRENTLY_SUPPORTED;
  const refundReduction = delivery?.emergency?.refundReduction;
  const isCancelableStatus = [
    ORDER_PHASE.PREPARING,
    ORDER_PHASE.CONTACTING,
  ].includes(status);
  const isRefundCancelable =
    isCancelableStatus &&
    !disabledCancel &&
    cancellableWithRefundAndPromo &&
    orderNotCurrentlySupported &&
    orderType === ORDER_TYPE_DELIVERY;

  if (!isRefundCancelable) return null;
  return (
    <Box sx={{ ...styles.section, padding: withPadding && "0px 16px 16px" }}>
      {isRefundCancelable && (
        <Button
          label="Annuler ma commande"
          onClick={async () => {
            await changeOrderType(
              setIsLoading,
              order,
              MODIFY_ORDER_TYPE_PROMOTION.REFUND,
              null,
              refundReduction
            );
          }}
          colorType={ERROR}
          size="large"
          width="100%"
        />
      )}
    </Box>
  );
}
